/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import { withStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Paper,
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { loadLoggedInUserInfo } from "./../../state_management/localStorage";

import AppDrawer from "../Composites/AppDrawer/AppDrawer";

import { withRouter } from "react-router-dom";

import logo from "../../assets/sainapse_logo2_white.png";
import UserInfoCard from "../../traditional/UserController/UserInfoCard";

const styles = (theme) => ({
  menuButton: {
    marginRight: theme.spacing(0),
  },
});

class AppToolBar extends Component {
  state = {
    open_drawer: false,
    userInformationDialogOpen: false,
  };

  toggleDrawer = () => {
    this.setState({
      open_drawer: !this.state.open_drawer,
    });
  };

  goToHome = () => {
    this.props.history.push({
      pathname: "/",
    });
  };

  renderUserInformationDialog = () => {
    return (
      <UserInfoCard
        open={this.state.userInformationDialogOpen}
        onClose={() => this.setState({ userInformationDialogOpen: false })}
      ></UserInfoCard>
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <AppBar style={{ margin: 0, padding: 0 }} position="sticky">
          <Toolbar style={{ maxHeight: 48 }} variant="dense">
            <IconButton
              id = "app-menu-button"
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={this.toggleDrawer}
            >
              <MenuIcon />
            </IconButton>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "",
                padding: "",
                cursor: "pointer",
                marginLeft : '10px',
              }}
              onClick={this.goToHome}
            >
              <img style={{ height: "30px" }} src={logo} alt="logo" />
            </div>
          </Toolbar>
          <IconButton
            id = "user-button"
            style={{
              position: "absolute",
              right: "10px",
              color: "#FFFFFF",
              borderColor: "#FFFFFF",
            }}
            onClick={() => {
              this.setState({
                userInformationDialogOpen: !this.state
                  .userInformationDialogOpen,
              });
            }}
          >
            <AccountCircle></AccountCircle>
          </IconButton>
        </AppBar>
        <AppDrawer open={this.state.open_drawer} toggle={this.toggleDrawer} />
        {this.state.userInformationDialogOpen
          ? this.renderUserInformationDialog()
          : null}
      </Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(AppToolBar));
